import React from 'react';
import { Table, Avatar, Button } from '@/components/ui';
import type { ConstructionQaInspection } from '../types/construction-qa.types';
import { QaStatusBadge } from './QaStatusBadge';
import { QaResultBadge } from './QaResultBadge';

interface Props {
  data: ConstructionQaInspection[];
  isLoading?: boolean;
  onViewDetail: (id: string) => void;
}

export const QaTable: React.FC<Props> = ({ data, isLoading, onViewDetail }) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
      <Table
        columns={[
          { key: 'code', title: 'Mã phiếu', width: '120px' },
          { key: 'type', title: 'Loại kiểm tra' },
          { key: 'target', title: 'Đối tượng / Khu vực' },
          { key: 'inspector', title: 'Người kiểm tra' },
          { key: 'score', title: 'Điểm / Tỉ lệ', align: 'right' },
          { key: 'result', title: 'Kết quả', align: 'center' },
          { key: 'status', title: 'Trạng thái', width: '120px' },
          { key: 'actions', title: '', width: '80px' },
        ]}
        data={data}
        isLoading={isLoading}
        renderCell={(row, key) => {
          switch (key) {
            case 'code':
              return <span className="text-xs font-mono font-bold text-os-primary">{row.inspection_code}</span>;
            case 'type':
              return <span className="text-xs font-medium text-slate-700">{row.inspection_type}</span>;
            case 'target':
              return (
                <div className="flex flex-col">
                  <span className="text-xs font-bold text-slate-700">{row.work_order?.title || '---'}</span>
                  <span className="text-[10px] text-slate-400">{row.zone?.name || '---'}</span>
                </div>
              );
            case 'inspector':
              return (
                <div className="flex items-center gap-2">
                  <Avatar src={row.inspector?.avatar_url} fallback={row.inspector?.full_name?.substring(0, 2)} size="xs" />
                  <span className="text-xs text-slate-600">{row.inspector?.full_name}</span>
                </div>
              );
            case 'score':
              return (
                <div className="flex flex-col items-end">
                  <span className="text-sm font-bold text-slate-900">{row.score.toFixed(1)}</span>
                  <span className="text-[10px] text-slate-400">{row.pass_rate}% đạt</span>
                </div>
              );
            case 'result':
              return <QaResultBadge result={row.result_code} />;
            case 'status':
              return <QaStatusBadge status={row.status_code} />;
            case 'actions':
              return (
                <Button 
                  variant="ghost" 
                  size="sm" 
                  icon="ri-arrow-right-line" 
                  onClick={() => onViewDetail(row.id)}
                />
              );
            default: return null;
          }
        }}
      />
    </div>
  );
};
